import { lazy } from 'react';
import { routeTree } from '@/routeTree.gen.ts';
import { PageLoader } from '@/shared/ui/PageLoader';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import ErrorPage from '@/pages/ErrorPage';

const NotFoundPage = lazy(() => import('@/pages/404'));

export const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultPendingComponent: PageLoader,
  defaultPendingMs: 300,
  defaultNotFoundComponent: NotFoundPage,
  defaultErrorComponent: ErrorPage,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default <RouterProvider router={router} />;
